import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { Add, Description } from "@mui/icons-material";
import RegularButton from "../../components/CustomButtons/Button";
import CardTable from "../../components/CardTable/CardTable";
import { ModalV2 } from "../../components/Modal/ModalV2";
import { configTable } from "./config";
import { DispenserUserInputs } from "./DispenserUserInputs";
import { FormDispenserUser } from "./FormDispenserUserEdit";
import { useTableDispenserUserConfig } from "./hooks";
import { useSearch } from "../../hooks/useSearch";
import { useToggle } from "../../hooks/useToggle";
import { resetDispenserUserSelected } from "../../redux/actions/dispenserUser/dispenserUserAction";

const dispensersSelector = createSelector(
  (state) => state.dispenserUser.filter(dispenser => !dispenser?.dispenserUser?.id),
  (dispensers) => dispensers
);

export default function DispenserUser () {
  const { buildCompLoadings } = useSearch();
  const dispatch = useDispatch();
  const [open, setOpen] = useToggle();
  const [ columnsData, setColumnsData ] = useState([]);
  const { dispenserUser, unit, config } = useSelector(({ dispenserUser }) => dispenserUser);
  const dispenserOptions = useSelector(({ dispenserUser }) => dispensersSelector(dispenserUser));
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { page, pageSize, sorted, filtered } = config;
  const {
    handleFilter,
    handlePage,
    handlePageSize,
    handleSort,
  } = useTableDispenserUserConfig();
  
  useEffect(() => buildCompLoadings(["loadingDispenserUser", "loadingDriverUser"]), []);
  
  useEffect(() => {
    setColumnsData(dispenserUser.map(dispenser => ({
      ...dispenser,
      modal: setOpen
    })));
    // eslint-disable-next-line
  }, [dispenserUser, isLoadingComp?.loadingDispenserUser]);

  useEffect(() => {
    if(!open) dispatch(resetDispenserUserSelected());
    // eslint-disable-next-line
  }, [open]);
  
  return (
    <>
      <CardTable
        data={columnsData}
        columns={configTable}
        hasHeader
        blockBtn
        title={"Usuario de Dispensador"}
        icon={<Description />}
        page={page}
        pageSize={pageSize}
        sorted={sorted}
        filtered={filtered}
        onFilteredChange={handleFilter}
        onPageSizeChange={handlePageSize}
        onPageChange={handlePage}
        onSortedChange={handleSort}
        isLoading={isLoadingComp?.loadingDispenserUser}
        tableContent={<DispenserUserInputs />}
        hasControl
        controls={
          <RegularButton
            round 
            justIcon 
            color="info" 
            tooltip="Crear Venta"
            onClick={setOpen}
            style={{ margin: 10 }}
            disabled={unit?.id && !dispenserOptions.length}
          >
            <Add style={{ margin: 0 }}/>
          </RegularButton>
        }
      />
      <ModalV2
        open={open}
        title='Agregar usuario de dispensador' 
        toRight
        onClose={setOpen}
      >
        <FormDispenserUser handleClose={setOpen}/>
      </ModalV2>
    </>
  );
}
